<div class="col-12 footer-admin pt-4">
    <div class="container-fluid font-size-14 d-lg-flex d-md-inline-flex justify-content-lg-between blue-0041A3">
        <p class="font-size-14">{{ '© 2021 Eficacia | Sales Hub. Todos los derechos reservados' | translate }}</p>
        <p><a href="#" class="link-black-0041A3">{{ 'Nuestras políticas' | translate }}</a></p>
        <p><strong>{{ 'Contacto:' | translate }}</strong> {{ '(57) 321 54160  -  saleshub@eficacia.com.co' | translate }}</p>
        <div class="">
            <a href="" target="_blank"><i class="icon-facebook font-size-14 blue-0041A3 mx-2"></i></a>
            <a href="" target="_blank"><i class="icon-twitter font-size-14 blue-0041A3 mx-2"></i></a>
            <a href="" target="_blank"><i class="icon-instagram font-size-14 blue-0041A3 mx-2"></i></a>
            <a href="" target="_blank"><i class="icon-linkedin font-size-14 blue-0041A3 mx-2"></i></a>
        </div>

    </div>

</div>
